<template>
	<div class="standRadioGroup">
		<label v-for="option in options" :key="option.text" :class="{ active: option.text === value }" :data-id="option.id">
			<input class="controlRadio-input" type="radio" :value="option.text" :checked="option.text === value" @change="$emit('input', option.text)">
			<span class="controlRadio-state"></span>
			<div class="standRadioGroup-title">{{ option.shortName ? option.shortName : option.text  }}</div>
			<div class="standRadioGroup-picture">
				<img v-if="option.image"
					:src="option.image" />
			</div>
		</label>
	</div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
	props: {
		options: {
			type: Array,
			default: [],
		},
		value: {},
	},
})
</script>
